<template>
    <div class="box">
        <div class="bg"></div>
        <div class="introduce">
            <div class="title">公司简介</div>
            
             <ul class="detail">
                <!-- <transition name="silider"> -->
                    <li v-for="(item,index) in content" :key="index">
                        <div>{{ item.title }}</div>
                        <div v-html="item.context"></div>
                        <!-- <div>{{ item.context }}</div> -->
                    </li>
                <!-- </transition> -->
            </ul>
        </div>
        <div class="bottom">
            <div class="line first">
                <span v-for="(item,index) in line" :key="index">{{ item }}</span>
            </div>
            <div class="line">
                <span>衡阳贾俊科技有限公司 版权所有©www.jiajunkj.top <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2024058088号-1</a ></span>
                <span>工商网监</span>
                <span>湘网文[2024]1741-031 号</span>
            </div>
        </div>
        <div class="logo">
            <div style="display:flex; ailgn-item:center">
                <img src="../assets/company.png" alt="">
                <div class="logo_text">贾俊科技</div>
            </div>        
            <div class="about">
                <ul>
                    <li @click="goDetail(item.link)" v-for="item in about" :key="item">{{ item.title }}</li>
                </ul>
            </div>
        </div>
        
    </div>
</template>

<script setup>
// import { useRouter } from 'vue-router';
// const router = useRouter()
const content = [
    {
        title: 'U秀直播',
        context: '为您提供<br />安全、绿色、健康的<br />直播环境。<br />我们严格筛选主播<br />确保内容优质<br />让您看得放心、玩得开心！'
    },
    {
        title: '直播功能',
        context: '用户可以进行实时视频直播<br />与观众进行互动交流。'
    },
    {
        title: '社交功能',
        context: '用户可以通过<br />私信、评论、点赞等方式<br />与其他用户互动，<br />增加社交互动的乐趣。'
    },
    {
        title: '礼物打赏',
        context: '观众可以给喜欢的主播送礼物，<br />表达对其的赞赏和支持。'
    },
    {
        title: '社群功能',
        context: '用户可以加入不同的<br />话题和兴趣社群，<br />与志同道合的人<br />进行交流和分享。'
    },
]
const about = [{
        title: '常见问题',
        link: '',
    },
    {
        title: '进入U秀',
        link: 'https://uxiutv.com/#/home',
    }]
const line = ['关于我们','联系客服', '我要直播', 'U秀官方QQ号']
const goDetail = (link) =>{
    window.location.href = link
}
</script>

<style scoped lang="scss">
.box{
    width: 100%;
    height: 100vh;
    position: relative;
    .bg{
        width: 100%;
        height: 600px;
        background: url('../assets/bg.jpg');
        background-size: cover;
    }
    .introduce{
            width: 100%;
            height: 520px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            z-index: 999;
            display: flex;
            flex-direction: column;
        .title{
            font-size: 40px;    
            font-weight: 600;
            text-align: center;
        }
        .detail{
            flex: 1;
            margin-top: 20px;
            padding: 50px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-evenly;
            text-align: center;
            li{
                width: 14%;
                background-color: rgba(250, 250, 250, 0.377);
                // background: linear-gradient(#bffbff,rgba(255, 154, 171, 0.281));
                border-radius: 20px;
                box-sizing: border-box;
                padding: 45px 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 0 2px 6px 0 #5a5a5a;
                div:nth-child(1){
                    font-size: 26px;
                    font-weight: 600;
                    margin-bottom: 16px;
                }
                div:nth-child(2){
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    line-height: 30px;
                }
            }
            li:hover{
                cursor: pointer;
                transform: scale(1.1);
                // color: rgb(255, 134, 174);
                // top: -20px;
            }
        }
    }
    .bottom{
        height: 425px;
        box-sizing: border-box;
        padding-top: 295px;
        font-size: 12px;
        .line{
            display: flex;
            justify-content: center;
            padding: 1px;
        }
        span{
            display: inline-block;
            height: 16px;
            padding: 0 8px;
            border-right: 1px solid rgb(190, 190, 190);
            &:last-child{
                border-right: 0;
            }
        }
        .first{
            span:hover{
                cursor: pointer;
                transform: scale(1.06);
                color: rgb(255, 134, 174);
            }
        }
        // background-color: rgba(230, 230, 230, 0.322);
        // background: linear-gradient((#ffc9de, 0, 0),rgb(204, 233, 255));
    }
    .logo{
        position: absolute;
        bottom: 80px;
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        padding: 10px 150px;
        display: flex;
        img{
            width: 40px;
        }
        .logo_text{
            font-weight: 600;
            font-size: 18px;
            line-height: 40px;
            margin-left: 6px;
        }
        .about{
            flex: 1;
            box-sizing: border-box;
            padding: 0 560px;
            ul{
                height: 100%;
                display: flex;
                align-items: center;
                // justify-content: center;
                li{
                    margin-right: 80px;
                    cursor: pointer;
                    &:last-child{
                        margin-right: 0;
                    }
                    &:hover{
                        color: rgb(255, 134, 174);
                    }
                }
            }
        }
    }
}
</style>